<template>
	<datatable size="large" :headers :value="items" expandable :loading>
		<template #row-desc="{ row }">
			<div v-if="row.type !== 'Component'">
				{{ row.desc }}
			</div>
			<div v-else>
				<span class="ml-3">{{ `&#x2022; ${row.desc}` }}</span>
			</div>
		</template>

		<template #row-item_weight="{ row }">
			{{ row.type === 'Kit' ? '-' : row.item_weight }}
		</template>

		<template #row-quantity_ok="{ row }">
			<quantity-field
				v-if="row.type !== 'Kit' && row.type !== 'Comprises Of'"
				v-model="row.quantity_ok"
				:max="row.none_stock == 1 ? row.quantity_on_hire : undefined"
				@update:model-value="emit('updatedItems', row)" />
		</template>

		<template #row-quantity_damaged="{ row }">
			<quantity-field
				v-if="row.type !== 'Kit' && row.type !== 'Comprises Of'"
				v-model="row.quantity_damaged"
				:max="row.none_stock == 1 ? row.quantity_on_hire : undefined"
				@update:model-value="emit('updatedItems', row)" />
		</template>

		<template #row-damage_code="{ row }">
			<div class="w-24">
				<app-button
					v-if="row.type !== 'Kit' && row.type !== 'Comprises Of'"
					:icon="row.damage_code ? 'fa-pencil' : 'fa-plus'"
					@click="emit('addEditDamageCodes', row)"
					>{{ row.damage_code ? 'Edit' : 'Add' }}
				</app-button>
			</div>
		</template>

		<template #row-notes="{ row }">
			<notes-button
				:status="{ notes: row.notes, notes_status: row.notes_status }"
				tablet
				@click="editingParent = row" />
		</template>
	</datatable>

	<edit-collection-item-note
		:item="editing ? editing : editingParent"
		@updated="emit('updatedNote', editingParent, editing)"
		@closed="((editing = undefined), (editingParent = undefined))" />
</template>

<script lang="ts" setup>
	import { ref } from 'vue'
	import QuantityField from '@/components/partials/tables/QuantityField.vue'
	import { CollectionItem } from '@/data/schema/collection-item'
	import EditCollectionItemNote from '@/components/partials/cat2/EditCollectionItemNote.vue'
	import NotesButton from '@/components/partials/cat2/NotesButton.vue'
	import type { Header } from '@/data/types/datatable'
	const editing = ref<CollectionItem | undefined>(undefined)
	const editingParent = ref<CollectionItem | undefined>(undefined)

	defineProps({
		items: {
			type: Array<CollectionItem>,
			default: []
		},
		loading: Boolean
	})

	const headers = ref<Header[]>([
		{ value: 'item_number', text: 'Item No', props: { sortable: true, width: 100 } },
		{
			value: 'item_description',
			text: 'Item Description',
			props: { sortable: true, width: 250 }
		},
		{ value: 'item_weight', text: 'Weight', props: { sortable: true, width: 100 } },
		{ value: 'quantity_recorded', text: 'Qty Rec', props: { sortable: true, width: 100 } },
		{ value: 'quantity_ok', text: 'OK', props: { sortable: true } },
		{ value: 'quantity_damaged', text: 'DAM' },
		{ value: 'damage_code', text: 'DAM CODE', props: { width: 100 } },
		{ value: 'notes', text: 'Notes' }
	])

	// Events
	const emit = defineEmits(['updatedItems', 'updatedNote', 'addEditDamageCodes'])
</script>
